import {useTranslation} from "react-i18next";
import Select from '@mui/material/Select';
import React from 'react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';

function TripSelect(props) {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const {trip, tripChange, enabled} = props;
	
	return (
		<Select native
		    size='small'
		    value={trip}
		    onChange={tripChange}
		    disabled={enabled === undefined ? false : !enabled}
		>
			{gStorage.lists.triplist.list.map((_trip) => {
				return (<option value={_trip.id} key={_trip.id}>{t(_trip.name)}</option>);
			})}
		</Select>
	);
}

export default TripSelect;
